import { render, staticRenderFns } from "./DepartmentsTree.vue?vue&type=template&id=16970261&scoped=true&"
import script from "./DepartmentsTree.vue?vue&type=script&lang=js&"
export * from "./DepartmentsTree.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentsTree.vue?vue&type=style&index=0&id=16970261&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16970261",
  null
  
)

export default component.exports